import { VCardDirectiveModule } from '@b2b/common/directives/vcard';
import { TODO, UIBModal } from '@b2b/types/core';
import angular, { ISCEService, IScope } from 'angular';

export const OrdersModalsChangeOrgControllerModule = angular.module('acme.view.application.orders.modals.changeOrg.controllers', [
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.factory.gridState',
  VCardDirectiveModule
])
.controller('OrdersModalsChangeOrgController', [
  '$scope',
  '$sce',
  '$uibModalInstance',
  'ApiService',
  'GridStateFactory',
  'nextOrganization',
  'currentOrder',
  function OrdersModalsChangeOrgController(
    $scope: IScope & { ordersModalsChangeOrg: TODO },
    $sce: ISCEService,
    $uibModalInstance: UIBModal<TODO>,
    ApiService: TODO,
    GridStateFactory: TODO,
    nextOrganization: TODO,
    currentOrder: TODO
  ) {
    $scope.ordersModalsChangeOrg = {

      model: {},
      list: [],
      contactsGridState: new GridStateFactory(),
      currentOrder: currentOrder,
      nextOrganization: nextOrganization,
      autoSelectedContact: {},
      currentOrderContact: {},
      contactType: 'auto',

      init: function() {

        this.currentOrderContact = {
          firstName: this.currentOrder.contactFirstName,
          lastName:  this.currentOrder.contactLastName,
          phoneNumber: this.currentOrder.phoneNumber,
          email: this.currentOrder.email
        };

        if (!this.currentOrder.accountId) {
          this.contactType = 'new';
        }

        this.searchContact();
      },

      getContacts: function() {
        this.contactsGridState.updateGridState(null, 5, 'name', 'asc', '');
        this.contactsGridState.gridState.search = '';
        if (nextOrganization && nextOrganization.company && nextOrganization.company.id) {
          ApiService.organizations.contacts.list(angular.extend({organizationId: nextOrganization.company.id}, this.contactsGridState.getGridState())).then(this.success.getContacts, this.error.getContacts);
        }
      },

      searchContact: function() {
        this.contactsGridState.updateGridState(null, 5, 'name', 'asc', '');
        if (currentOrder.email) {
          this.contactsGridState.gridState.search = currentOrder.email;
        }
        if (nextOrganization && nextOrganization.company && nextOrganization.company.id) {
          ApiService.organizations.contacts.list(angular.extend({organizationId: nextOrganization.company.id}, this.contactsGridState.getGridState())).then(this.success.searchContact, this.error.searchContact);
        }
      },

      findPrimaryOrFirstSecondaryContact: function() {
        var i, ii;

        if (this.list instanceof Array && this.list.length) {
          this.autoSelectedContact = this.list[0];

          for (i = 0, ii = this.list.length; i < ii; i++) {
            if (this.list[i].primary) {
              this.autoSelectedContact = this.list[i];
              break;
            }
          }
        }
      },

      done: function (selectedContact) {
        var contact;

        if (selectedContact) {
          contact = selectedContact;
          this.currentOrderContact = selectedContact;
          this.autoSelectedContact = selectedContact;
          this.contactType = 'auto';
        }else {
          if (this.contactType === 'auto') {
            contact = this.autoSelectedContact;
          } else {
            contact = this.currentOrderContact;
          }
        }
        contact.type = this.contactType;
        $uibModalInstance.close(contact);
      },

      cancel: function () {
        $uibModalInstance.dismiss('cancel');
      },

      success: {
        init: function(response) {},
        getContacts: function(response) {
          var self = $scope.ordersModalsChangeOrg;

          self.list = response.data.payload.list;
          self.findPrimaryOrFirstSecondaryContact();

        },

        searchContact: function(response) {
          var self = $scope.ordersModalsChangeOrg,
              contacts = response.data.payload.list;

          if (contacts && contacts.length) {
            if (contacts[0]) {
              self.done(contacts[0]);
            }else{
              self.getContacts();
            }
          }else{
            self.getContacts();
          }
        }
      },

      error: {
        init: function(response) {},
        getContacts: function(response) {},
        searchContact: function(response) {}
      }

    };

    $scope.ordersModalsChangeOrg.init();

}]).name;